// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8860c601","431":"6830a372","489":"e0763b44","507":"f749f3b1","608":"4ced33ee","787":"17672a46","880":"763eff94"}[chunkId] + ".chunk.js";
};